import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{attrs:{"fluid":""}},[_c(VRow,{attrs:{"align":"center","justify":"center"}},[_c('SSO',{attrs:{"external-name":_vm.partnerShortName}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }